import { render } from "./companyCertificate.vue?vue&type=template&id=988a5d9c&scoped=true"
import script from "./companyCertificate.vue?vue&type=script&lang=js"
export * from "./companyCertificate.vue?vue&type=script&lang=js"

import "./companyCertificate.vue?vue&type=style&index=0&id=988a5d9c&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-988a5d9c"]])

export default __exports__